const my_profile = {
  viewMyClubSeacretProfile: "Ver Perfil do Meu ClubeSeacret", // translated
  viewMoreDetails: "Ver mais detalhes", // translated
  unverifiedEmail: "E-mail não verificado", // translated
  verifiedEmail: "E-mail verificado", // translated
  createdFrom: "Criado a partir de", // translated
  createdTo: "Criado até", // translated
  selectStatus: "Selecionar status...", // translated
  searchByTitle: "Pesquisar por título...", // translated
  pushNotifications: "Notificações Push",
  pushNotificationsDescription: "Receba notificações do navegador para atualizações e eventos importantes",
  pushNotificationsNotSupported: "As notificações push não são suportadas neste navegador",
  pushNotificationsDeniedMessage: "A permissão de notificação foi negada. Por favor, habilite as notificações nas configurações do navegador para receber notificações push.",
  pushNotificationsEnabled: "Notificações push habilitadas com sucesso",
  pushNotificationsDisabled: "Notificações push desabilitadas com sucesso",
  userInformationMissing: "Informações do usuário estão faltando",
  failedToUpdatePushNotifications: "Falha ao atualizar as configurações de notificações push",
  notificationPermissionDenied: "A permissão de notificação foi negada. Por favor, habilite-a nas configurações do navegador.",
  notificationPermissionRequired: "A permissão de notificação é necessária para habilitar notificações push",
  notSupported: "Não suportado",
  permissionDenied: "Permissão negada",
  permissionNotRequested: "Permissão não solicitada",
  enabled: "Habilitado",
  disabled: "Desabilitado",
};

export default my_profile;
